"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { PillSection, StyledLink, PillContentWrapper, StyledShape } from "./styles.js";
import { INVALID_PROPS_ERROR, ELEMENT_TYPES, INVALID_COMPONENT_TYPE, PILL_BADGE_COLOR_MAP, FALLBACK_PILL_BADGE_COLOR, COMPONENT_NAME } from "./types.js";
import { Text } from "../Text/index.js";
import { getDataTestId } from "../../Util/index.js";
const PillBadge = ({
  text,
  color,
  link,
  componentType = "div",
  uniqueId,
  dataPrivate = false
}) => {
  if (!text || !link) {
    console.error(INVALID_PROPS_ERROR);
    return null;
  }
  if (!ELEMENT_TYPES.includes(componentType)) {
    console.error(INVALID_COMPONENT_TYPE);
    return null;
  }
  const pillBadgeColor = PILL_BADGE_COLOR_MAP[color] ?? FALLBACK_PILL_BADGE_COLOR;
  return /* @__PURE__ */ jsx(
    PillSection,
    {
      component: componentType,
      "data-testid": getDataTestId(COMPONENT_NAME, uniqueId),
      children: /* @__PURE__ */ jsx(
        StyledLink,
        {
          href: link,
          dataPrivate: Boolean(dataPrivate),
          uniqueId,
          underline: "none",
          children: /* @__PURE__ */ jsxs(
            PillContentWrapper,
            {
              wrapperBackgroundColor: pillBadgeColor.backgroundColor,
              wrapperHoverBackgroundColor: pillBadgeColor.hoverBackgroundColor,
              children: [
                /* @__PURE__ */ jsx(Text, { variant: "l2", sx: { color: pillBadgeColor.textColor }, children: text }),
                /* @__PURE__ */ jsx(StyledShape, {})
              ]
            }
          )
        }
      )
    }
  );
};
PillBadge.displayName = COMPONENT_NAME;
export {
  PillBadge
};
